import { ColorValues, Flex } from '@banhala/ui-kit';
import { BrandIconThirdPlDelivery } from '../../../../BrandIcon';

/**
 * - ui-kit `Chip` 의 size "medium" 스케일. `TodayChip`(오늘출발 칩)도 이 값을 쓴다.
 * - 같은 리스트에 나란히 놓이므로 높이·모서리가 어긋나지 않게 그대로 맞춘다.
 */
const CHIP_PADDING_HORIZONTAL = 12;
const CHIP_PADDING_VERTICAL = 9;
const CHIP_BORDER_RADIUS = 18;

/** `BrandIconTodayShipping` 과 동일한 렌더 크기(49x14)로 맞춰 칩 높이를 일치시킨다. */
const ICON_WIDTH = 49;
const ICON_HEIGHT = 14;

type ThirdPlDeliveryChipProps = {
  isSelected: boolean;
  onPress: VoidFunction;
};

/**
 * - 도착보장 필터 칩. 오늘출발 칩(ui-kit `TodayChip`)의 도착보장 버전이다.
 * - ui-kit `Chip` 은 children 을 텍스트로 렌더해 브랜드 워드마크를 넣을 수 없다.
 *   `TodayChip` 도 같은 이유로 `Chip` 을 쓰지 않고 컨테이너를 직접 조립하므로,
 *   그 구성(테두리/배경/여백/모서리)을 그대로 따라간다.
 * - 선택 상태 색이 핑크가 아니라 slate 인 것은 `TodayChip` 을 비롯한 이 리스트의
 *   모든 칩이 쓰는 공통 선택 색이기 때문이다.
 */
export const ThirdPlDeliveryChip = ({
  isSelected,
  onPress,
}: ThirdPlDeliveryChipProps) => {
  return (
    <Flex.Row
      alignItems="center"
      justifyContent="center"
      borderWidth={1}
      borderRadius={CHIP_BORDER_RADIUS}
      padding={{
        horizontal: CHIP_PADDING_HORIZONTAL,
        vertical: CHIP_PADDING_VERTICAL,
      }}
      borderColor={isSelected ? 'bg_slate_primary' : 'border_secondary'}
      backgroundColor={isSelected ? 'bg_slate_primary' : 'transparent'}
      onPress={onPress}
    >
      <BrandIconThirdPlDelivery
        width={ICON_WIDTH}
        height={ICON_HEIGHT}
        color={isSelected ? ColorValues.white : ColorValues.pink30}
      />
    </Flex.Row>
  );
};
